const c="#include <stdio.h>\nint main()\n{\n\tprintf('Hello World!');\n\treturn 0;\n}";
const cpp="#include <bits/stdc++.h>\n#include <iostream>\nusing namespace std;\n\nint main()\n{\n\tcout << \"Hello World!\" << endl;\n\treturn 0;\n}"
const python2="print 'Hello World!'";
const python3="print ('Hello World!')";
const Java="public class Main {\n\tpublic static void main(String[] args) {\n\tSystem.out.println('Hello World!');\n\t}\n}";
const Javascript="(function main() {\n\tconsole.log('Hello World!');\n}());";
const NodeJS="console.log('This example is different!');";
const Ruby="puts 'Hello World!'";
const cpp14="#include <bits/stdc++.h>\n#include <iostream>\nusing namespace std;\n\nint main()\n{\n\tcout << \"Hello World!\" << endl;\n\treturn 0;\n}";
const csharp="class HelloWorld {\n\tstatic void Main() {\n\tSystem.Console.WriteLine('Hello World!');\n}\n}";
export {cpp,c,python2,python3,Java,Javascript,NodeJS,Ruby,cpp14,csharp};